export default __webpack_public_path__ + "static/media/AttentionIcon.9088464c.gif";